import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import {
  AccordionDefault,
  AccordionItem,
} from '../accordion-default/accordion-default';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  selector: 'app-layout-cindi-equilibria',
  imports: [MatExpansionModule, AccordionDefault],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './layout-cindi-equilibria.html',
  styleUrl: './layout-cindi-equilibria.scss',
})
export class LayoutCindiEquilibria implements OnInit {
  @Input() detalhesTriagem: any = null;
  readonly panelOpenState = signal(false);
  triagemPreenchida = signal(false);

  ngOnInit(): void {
    this.setBioPsicossociais();
    this.setHabitantesAlimentares();
    this.setAtividadesFisicas();
    this.setAspectosPsicoemocionais();
    this.setImpactoLaboral();
    this.setTransteorico();
    this.setFinalizacao();
    this.setRiscoEIMC();
    this.atualizaStatusTriagemPreenchida();
  }

  imc = signal(0);
  risco = signal('');
  setRiscoEIMC() {
    this.imc.set(this.detalhesTriagem.imc ?? 0);
    this.risco.set(this.detalhesTriagem.risco ?? '');
  }

  bioPsicossocial: AccordionItem[] = [];
  setBioPsicossociais() {
    const b = this.detalhesTriagem.biopsicossociais ?? {};

    this.bioPsicossocial = [
      {
        title: 'Em qual país você nasceu?',
        content: b.pais ?? '',
      },
      {
        title: 'Em qual cidade você reside atualmente?',
        content: b.cidade ?? '',
      },
      {
        title: 'Qual é o seu estado civil?',
        content: b.estadoCivil ?? '',
      },
      {
        title: 'Qual o seu grau de escolaridade?',
        content: b.escolaridade ?? '',
      },
      {
        title: 'Como você se identifica no quesito étnico-racial?',
        content: b.etnicoSocial ?? '',
      },
      {
        title: `Qual o seu cargo na ${this.detalhesTriagem.nomeEmpresa}?`,
        content: b.cargo ?? '',
      },
      {
        title: `Qual o local que você atua aqui na ${this.detalhesTriagem.nomeEmpresa}?`,
        content: b.localQueAtua ?? '',
      },
      {
        title: `Em qual turno você trabalha na ${this.detalhesTriagem.nomeEmpresa}?`,
        content: Array.isArray(b.turno) ? b.turno.join(', ') : (b.turno ?? ''),
      },
      {
        title: 'Você tem histórico familiar de condições crônicas?',
        content: b.historicoFamiliar ?? '',
      },
      {
        title: 'Você tem alguma condição crônica?',
        content: b.condicaoCronica ?? '',
      },
      {
        title: 'Qual o seu peso?',
        content: b.peso ?? '',
      },
      {
        title: 'Qual a sua altura?',
        content: b.altura ?? '',
      },
    ];
  }

  habitosAlimentares: AccordionItem[] = [];
  setHabitantesAlimentares() {
    const t = this.detalhesTriagem.habitosAlimentares ?? {};
    this.habitosAlimentares = [
      {
        title:
          'Ao longo da semana, quais alimentos in natura ou minimamente processados você costuma consumir?',
        content: t.inNatura ?? '',
      },
      {
        title: 'Com que frequência você costuma consumir esses alimentos?',
        content: t.frequenciaInNatura ?? '',
      },
      {
        title:
          'Ao longo da semana, quais alimentos processados você costuma consumir?',
        content: t.processados ?? '',
      },
      {
        title: 'Com que frequência você costuma consumir esses alimentos?',
        content: t.frequenciaProcessados ?? '',
      },
      {
        title:
          'Ao longo da semana, quais ultraprocessados você costuma consumir e com qual frequência?',
        content: t.ultraprocessados ?? '',
      },
      {
        title: 'Com que frequência você costuma consumir esses alimentos?',
        content: t.frequenciaUltraprocessados ?? '',
      },
      {
        title:
          'Qual é a quantidade de água que você consome por dia? \n*1 copo (200 ml)',
        content: t.quantidadeDeAgua ?? '',
      },
    ];
  }

  atividadesFisicas: AccordionItem[] = [];
  setAtividadesFisicas() {
    const t = this.detalhesTriagem.atividadesFisicas ?? {};
    this.atividadesFisicas = [
      {
        title:
          'Ao longo da semana, com que frequência você pratica atividades físicas?',
        content: t.frequencia ?? '',
      },
      {
        title: 'Quanto tempo, em média, dura sua sessão de atividade física?',
        content: t.duracao ?? '',
      },
    ];
  }

  aspectosPsicoemocionais: AccordionItem[] = [];
  setAspectosPsicoemocionais() {
    const t = this.detalhesTriagem.aspectosPsicoemocionais ?? {};
    this.aspectosPsicoemocionais = [
      {
        title:
          'Você percebe que, quando está emocionalmente abalado, tende a fazer escolhas alimentares menos equilibradas?',
        content: t.emocionalmenteAbalado ?? '',
      },
      {
        title:
          'Você já percebeu que seu estado emocional interfere na sua motivação ou regularidade para praticar atividades físicas?',
        content: t.estadoEmocionalInterfere ?? '',
      },
    ];
  }

  impactoLaboral: AccordionItem[] = [];
  setImpactoLaboral() {
    const t = this.detalhesTriagem.impactoLaboral ?? {};
    this.impactoLaboral = [
      {
        title:
          'Você sente que, devido ao sobrepeso ou à obesidade, tem enfrentado alguma dificuldade para realizar suas atividades do dia a dia?',
        content: t.enfrentaDificuldades ?? '',
      },
      {
        title:
          'Você percebe que, por conta do sobrepeso ou da obesidade, tem se sentido menos produtivo do que gostaria?',
        content: t.menosProdutivo ?? '',
      },
    ];
  }

  transteorico: AccordionItem[] = [];
  setTransteorico() {
    const t = this.detalhesTriagem.transteorico ?? {};
    this.transteorico = [
      {
        title:
          'Qual das alternativas abaixo você se identifica para tomar atitudes em relação a forma como você se alimenta, se movimenta, gerencia suas emoções e o seu sono?',
        content: t.atitudes ?? '',
      },
    ];
  }

  finalizacao: AccordionItem[] = [];
  setFinalizacao() {
    const f = this.detalhesTriagem.finalizacao ?? {};

    this.finalizacao = [
      {
        title:
          'Tem mais alguma questão relacionada à sua saúde que está te incomodando ou preocupando?',
        content: f.possuiOutraPreocupacao ?? '',
      },
      {
        title:
          'Se você se sentir à vontade, gostaria que me contasse um pouco mais sobre o que tem te preocupado.',
        content: f.descricaoPreocupacao ?? '',
      },
      {
        title: 'Pesquisa de satisfação',
        content: String(f.satisfacao ?? 0),
      },
    ];
  }

  atualizaStatusTriagemPreenchida() {
    return [
      ...this.bioPsicossocial,
      ...this.habitosAlimentares,
      ...this.atividadesFisicas,
      ...this.aspectosPsicoemocionais,
      ...this.impactoLaboral,
      ...this.transteorico,
      ...this.finalizacao,
    ].filter((item: AccordionItem) => {
      if (!!item.content) {
        this.triagemPreenchida.set(true);
        return;
      }
    });
  }
}
